import React, { useContext, useRef } from 'react'
import { Colored } from '../styles/elements'
import {
  GiftCode, GiftCodeLabel, GiftCodeValue, CopySucceed, VoucherGift
} from '../styles/gift'
import { LocaleContext } from '../routes'

export default ({ label, code, type }) => {
  const locale = useContext(LocaleContext)
  const codeInput = useRef()
  const copiedText = useRef()

  const endCopied = e => {
    e.target.classList.remove("animation");
  }

  const copyCode = () => {
    const giftCode = codeInput.current
    giftCode.select()
    giftCode.setSelectionRange(0, 99999)
    document.execCommand("copy")

    const copied = copiedText.current
    copied.classList.add("animation")
  }

  return (
    <GiftCode>
      {code &&
        <>
          <GiftCodeLabel>{locale[label]}</GiftCodeLabel>
          <GiftCodeValue
            value={code}
            onClick={copyCode}
            ref={codeInput}
            readOnly
          />
          <Colored color="orangered" onClick={copyCode}>{locale.COPY}</Colored >
          <CopySucceed ref={copiedText} onAnimationEnd={endCopied}>{locale.COPIED}!</CopySucceed>
        </>
      }
      {!code && type === 'INTERNAL' &&
        <VoucherGift>
          {locale.PRODUCT_IS_ADDED_TO_VOUCHERLIST}.
        </VoucherGift>
      }
    </GiftCode>
  )
}
